import ScrollableDiv from './ScrollableDiv';

export default ScrollableDiv;
